import {

    SalesDocument,
    ClientAddress,
    DocumentErrors

} from '@icc/b2b/shared';

import { TranslateService } from '@icc/shared';


function validationDocumentAddress(address: ClientAddress, translateService:TranslateService):string[]{

    const errors = [];

    if(!address || typeof address !== 'object'){
        errors.push(translateService.instant(
            'CONTACT|Nieprawidłowy adres do wysyłki zamówień'
        ));
    }else{

        if(!address?.addressLine1 || typeof address.addressLine1 !== 'string'){
            errors.push(translateService.instant(
                'CONTACT|Nieprawidłowy lub pusty adres w lini pierwszej'
            ));
        }

        if(!address?.postalCode || typeof address.postalCode !== 'string'){
            errors.push(translateService.instant(
                'CONTACT|Nieprawidłowy lub pusty kod pocztowy'
            ));
        }

        if(!address?.city || typeof address?.city !== 'string'){
            errors.push(translateService.instant(
                'CONTACT|Nieprawidłowa lub pusta miejscowość'
            ));
        }

    }

    return errors;


}

function validationDocumentClient(document: SalesDocument, translateService:TranslateService):string[]{

    let errors = [];

    if(!document?.client || typeof document?.client !== 'object'){
        errors.push(translateService.instant(
            'SALES_DOCUMENT|Brak danych kontrahenta.'
        ));
    }else{

        if(!document?.client?.firstName || typeof document?.client?.firstName !== 'string'){
            errors.push(translateService.instant(
                'SALES_DOCUMENT|Uzupełnij imię kontrahenta.'
            ));
        }

        if(!document?.client?.lastName || typeof document?.client?.lastName !== 'string'){
            errors.push(translateService.instant(
                'SALES_DOCUMENT|Uzupełnij nazwisko kontrahenta.'
            ));
        }

        if(!document?.client?.phoneNumber || typeof document?.client?.phoneNumber !== 'string'){
            errors.push(translateService.instant(
                'SALES_DOCUMENT|Uzupełnij numer telefonu kontrahenta.'
            ));
        }

        if(!document?.client?.email || typeof document?.client?.email !== 'string'){
            errors.push(translateService.instant(
                'SALES_DOCUMENT|Uzupełnij adres e-mail kontrahenta.'
            ));
        }

        errors = validationDocumentAddress(document?.client?.delivery ,translateService);

    }

    return errors;

}

export function validationDocument(document: SalesDocument, translateService:TranslateService):DocumentErrors{

    const documentErrors: DocumentErrors = {
        errors: [],
        client:{
            errors: [],
            contact: {
                errors: [],
            },
            invoice: {
                errors: [],
            },
        }
    };

    documentErrors.client.errors = validationDocumentClient(document,translateService);

    if(document?.client?.billingDelivery && Object.keys(document?.client?.billingDelivery).length ){
        documentErrors.client.contact.errors = validationDocumentAddress(document?.client.billingDelivery,translateService);
    }

    if(document?.client?.invoice  && Object.keys(document?.client?.invoice).length){
        documentErrors.client.invoice.errors = validationDocumentAddress(document?.client.invoice,translateService);
    }

    return documentErrors;
}